import { TYPES_CONFIG } from '../../../constants';
export var getLabel = function getLabel(propertyType, operator) {
  var operatorsConfig = TYPES_CONFIG[propertyType];

  if (operatorsConfig && operator) {
    var label = operatorsConfig[operator].label;
    return label;
  }

  return null;
};